module.exports = __webpack_public_path__ + "static/img/RayWhite.ae5a0c1c.png";